import { serverErrorNotification } from "@/apps/admin/features/notifications/notificationSlice";
import type { BaseQueryPolicy } from "@/state/api/createBaseQuery";
import { failureText } from "@/state/api/requestFailure";

/**
 * Admin's behaviour around every request (GEN5-5269 ARCHITECTURE item 3):
 * failures toast verbosely (AD1, D3: `failureText(…, "verbose")`); the
 * permissions a response states are not collected (admin's come from its own
 * guard). Given to admin's store, so layout's API, when the shared Genie
 * mounts it there, behaves as admin's too.
 */
export const ADMIN_POLICY: BaseQueryPolicy = {
  // Every failure is told unless the endpoint says otherwise (AD1).
  defaultNotify: "always",
  onError: (failure, api) => {
    api.dispatch(serverErrorNotification(failureText(failure, "verbose")));
  },
};
